import { dispatchEvent } from '../shared/events';

class _Controller {

  constructor($limits, $saveToList) {
    this.$saveToList = $saveToList;
    this.$limits = $limits;
  }

  newSave(collection) {
    this.$saveToList.newAppend(collection);
  }

  clickedDisabledSave() {
    dispatchEvent('clickedSaveToList');
  }

}

_Controller.$inject = ['$limits', '$saveToList'];

export const saveToListButton = {
  bindings: { collection: '<' },
  controller: _Controller,
  template: `
    <button class='save-to-list' ng-if='$ctrl.$limits.cant("lists")' ng-click='$ctrl.clickedDisabledSave()' ng-disabled='!$ctrl.collection.keywords || $ctrl.collection.keywords && ($ctrl.collection.getActionable().length < 1)'>Save</button>
    <button class='save-to-list' ng-if='$ctrl.$limits.can("lists")' ng-click='$ctrl.newSave()' ng-disabled='!$ctrl.collection.keywords || $ctrl.collection.keywords && ($ctrl.collection.getActionable().length < 1)'>Save</button>
  `
}
